import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import "react-datetime/css/react-datetime.css";
import { Tab, Card, Table, TableRow, TableBody, TableCell, Container, TableContainer, TablePagination, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import { UserListHead } from "../../sections/@dashboard/user";
import { GetActiveContestMatchAction, ResetPublishMatchPool } from "../../redux/actions/MatchAction";
import { GetAllContestAction } from "../../redux/actions/ContestActions";
import "react-toastify/dist/ReactToastify.css";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import Loader from "src/components/Loader";

export default function ActivePoolList() {
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();
  const poolListData = useSelector((state) => state.matches.active_pool_list.data);
  const statusSelector = useSelector((state) => state.matches.match_status);
  const [page, setPage] = useState(0);
  const [clickStatus, setClickStatus] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [publichClick, setPublichClick] = useState(false);
  const [filterContestList, setFilterContestList] = useState();

  const [state, setState] = useState({
    totalCountPoolList: 0,
    logoImg: [],
    joinfee: null,
    totalwinamt: null,
    maxteams: null,
    winners: null,
    contest_id: null,
    pool_text: "Add Pool",
    countrytype: "all",
    matchType: location.state.type,
    isCheckedPool: 1,
    contest_id_pool: null,
    contest_id_pool_date: null,
    pool_start_date: "",
    pool_end_date: "",
  });
  const [value, setValue] = useState("Contest");
  let Totaljoineduser = 0;
  let Totaljoinfee = 0;
  let Totalwinsum = 0;
  let Totaltotalamtjoiniii = 0;
  let Totalplatformrake = 0;
  let TotalRefunded = 0;

  let sendData = {
    match_id: id,
    contest_id: state.contest_id_pool,
    type: location.state.type,
    gtype: location.state.gtype,
    typeData: "Contest",
  };
  if (state.countrytype !== "all") {
    sendData["countrytype"] = state.countrytype;
  }

  // let activeSendData = {
  //     ...sendData,
  //     countrytype: "+91"
  // }
  const handleChange = (_, newValue) => {
    setValue(newValue);
    sendData["typeData"] = newValue;
    dispatch(GetAllContestAction(sendData));
    dispatch(GetActiveContestMatchAction(page + 1, rowsPerPage, sendData));
  };

  useEffect(() => {
    dispatch(GetAllContestAction(sendData));
    dispatch(GetActiveContestMatchAction(page + 1, rowsPerPage, sendData));
    setClickStatus(false);
  }, [dispatch, page, rowsPerPage]);

  useEffect(() => {
    if (Object.keys(statusSelector).length > 0 && publichClick) {
      dispatch(GetActiveContestMatchAction(page + 1, rowsPerPage, sendData));
      dispatch(GetAllContestAction(sendData));
      setClickStatus(false);
      setPublichClick(false);
      dispatch(ResetPublishMatchPool());
    }
  }, [statusSelector, page, rowsPerPage, publichClick]);

  useEffect(() => {
    var new_arr = poolListData && poolListData?.contestData?.filter((value, index, self) => index === self.findIndex((t) => t._id === value._id));
    setFilterContestList(new_arr);
  }, [poolListData]);

  useEffect(() => {
    if (poolListData !== undefined) {
      setState({
        ...state,
        totalCountPoolList: poolListData.total_count,
      });
    }
  }, [poolListData]);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  return (
    <Page title="Active Pools">
      {clickStatus ? <Loader /> : null}
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={location.state.name}
          links={[{ name: "Dashboard", href: "/dashboard/app" }, { name: "Active Matches", href: "/dashboard/cricket/active_match_list" }, { name: "Contest Status" }]}
        />
        <Card>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="Status management Tabs">
                <Tab label="Contest" value="Contest" key="0" />
                <Tab label="Accumulator " value="Accumulator" key="1" />
              </TabList>
            </Box>
            <TabPanel value="Contest" key="0">
              <TableContainer sx={{ minWidth: 800, minHeight: 100 }}>
                <Table>
                  <UserListHead
                    headLabel={[
                      { id: "joineduser", label: "Total User Join", alignRight: false },
                      // { id: "joinfee", label: "Join Fee", alignRight: false },
                      { id: "winsum", label: "Total Win", alignRight: false },
                      { id: "totalamtjoiniii", label: "Total Joining Amount", alignRight: false },
                      { id: "platformrake", label: "Platform Rake", alignRight: false },
                      { id: "refunded", label: "Refunded", alignRight: false },
                    ]}
                  />
                  <TableBody>
                    {poolListData &&
                      poolListData?.contestData?.map((data, index) => {
                        Totaljoineduser += data.joineduser;
                        Totaljoinfee += data.joinfee;
                        Totalwinsum += data.winsum;
                        Totaltotalamtjoiniii += data.joineduser * data.joinfee;

                        if (data.joineduser > 1) {
                          Totalplatformrake += data.joineduser * data.joinfee - data.winsum;
                        } else {
                          TotalRefunded += data.joineduser * data.joinfee;
                        }
                      })}
                    <TableCell component="th" scope="row">
                      {Totaljoineduser}
                    </TableCell>
                    {/* <TableCell component="th" scope="row">
                                {Totaljoinfee}
                            </TableCell> */}
                    <TableCell component="th" scope="row">
                      {Totalwinsum}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {Totaltotalamtjoiniii}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {Totalplatformrake}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {TotalRefunded}
                    </TableCell>
                  </TableBody>
                </Table>
              </TableContainer>
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800, minHeight: 400 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={[
                        { id: "c_no", label: "Sr no.", alignRight: false },
                        { id: "c_id", label: "Title", alignRight: false },
                        { id: "c_title", label: "subtitle", alignRight: false },
                        { id: "joineduser", label: "Total User Join", alignRight: false },
                        { id: "joinfee", label: "Join Fee", alignRight: false },
                        { id: "winsum", label: "Total Win", alignRight: false },
                        { id: "totalamtjoiniii", label: "Total Joninig Amount", alignRight: false },
                        { id: "platformrake", label: "platform rake", alignRight: false },
                      ]}
                      rowCount={state.totalCountPoolList}
                      // onRequestSort={handleRequestSort}
                    />
                    <TableBody>
                      {poolListData &&
                        poolListData?.contestData?.map((data, index) => {
                          return (
                            <TableRow key={data.id}>
                              <TableCell component="th" scope="row">
                                {page * rowsPerPage + (index + 1)}.
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.cont_title}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.cont_subtitle}
                              </TableCell>

                              <TableCell component="th" scope="row">
                                {data.joineduser}
                              </TableCell>

                              <TableCell component="th" scope="row">
                                {data.joinfee}
                              </TableCell>

                              <TableCell component="th" scope="row">
                                {data.winsum}
                              </TableCell>

                              <TableCell component="th" scope="row">
                                {data.joineduser * data.joinfee}
                              </TableCell>

                              <TableCell component="th" scope="row">
                                {data.joineduser == 1 ? <span style={{ color: "green" }}>Refunded</span> : data.joineduser * data.joinfee - data.winsum}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[25, 50, 100, 150, 200]}
                component="div"
                count={state.totalCountPoolList}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TabPanel>

            <TabPanel value="Accumulator" key="1">
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800, minHeight: 400 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={[
                        { id: "c_no", label: "Sr no.", alignRight: false },
                        { id: "usersum", label: "No.Of User", alignRight: false },
                        { id: "rshrsum", label: "No.Of shares taken", alignRight: false },
                        { id: "wincnt", label: "No.Of shares winning", alignRight: false },
                        { id: "rtgkamount", label: "Total join amount", alignRight: false },
                        { id: "winamt", label: "Total Win", alignRight: false },
                        { id: "platform fee", label: "Platform fee", alignRight: false },
                        { id: "platformrake", label: "Platform rake", alignRight: false },
                        { id: "platformcommission", label: "Platform commission", alignRight: false },
                      ]}
                      rowCount={state.totalCountPoolList}
                      // onRequestSort={handleRequestSort}
                    />
                    <TableBody>
                      {poolListData && poolListData?.contestData?.length > 0 ? (
                        poolListData.contestData.map((data, index) => (
                          <TableRow key={data.id}>
                            <TableCell component="th" scope="row">
                              {page * rowsPerPage + (index + 1)}.
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.usersum}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.rshrsum}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.wincnt}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.rtgkamount}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.winamt}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.pltfeeamt}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.rtgkamount - data.winamt}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.pltfeeamt + data.rtgkamount - data.winamt}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={9} align="center">
                            No records found.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[25, 50, 100, 150, 200]}
                component="div"
                count={state.totalCountPoolList}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </Page>
  );
}
